import { render, staticRenderFns } from "./upcoming-renewal.vue?vue&type=template&id=e52d8e56"
import script from "./upcoming-renewal.vue?vue&type=script&lang=js"
export * from "./upcoming-renewal.vue?vue&type=script&lang=js"
import style0 from "./upcoming-renewal.vue?vue&type=style&index=0&id=e52d8e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports